// extracted by mini-css-extract-plugin
module.exports = {"component":"image-item_component_2pLzo","image":"image-item_image_2_4PQ","link":"image-item_link_1sOQs","description":"image-item_description_15-fJ"};